/*
 * Clears all fields in job plan
 */
export default (context:any, payload:any) => {
    const moduleId = context.getters.moduleId;

    const setAttribute = payload.oneLni.storeUtils.setAttribute;
    setAttribute(context, `${moduleId}_task`, 'value', '');

    setAttribute(context, `${moduleId}_location`, 'value', '');
    setAttribute(context, `${moduleId}_location-collapse`, 'visible', false);

    setAttribute(context, `${moduleId}_tool`, 'value', '');
    setAttribute(context, `${moduleId}_tool-collapse`, 'visible', false);

    setAttribute(context, `${moduleId}_variation`, 'value', '');
    setAttribute(context, `${moduleId}_variation-collapse`, 'visible', false);

    setAttribute(context, `${moduleId}_hours`, 'value', '');
    setAttribute(context, `${moduleId}_minutes`, 'value', '');
    setAttribute(context, `${moduleId}_quantity`, 'value', '');

    context.commit('REMOVE_TRACKED_ERRORS', [
        `${moduleId}_location`,
        `${moduleId}_tool`,
        `${module}_variation`,
    ]);

    // Hide error container so it doesn't display errors as user inputs information
    setAttribute(context, `${moduleId}_errors`, 'visible', false);
    // TODO: Clear inline messages

    context.commit('appState/SET_EDIT_INDEX', null, { root: true });
    context.commit('CLEAR_PATH_PARAMS');
};